@if(addingKeyword) {
  <div class="row justify-content-start">
    <div class="col-auto">
      <ng-container *ngTemplateOutlet="keyword"></ng-container>
    </div>
    <div class="col-auto" *ngIf="!customer.IsCampaignNational">
      <ng-container *ngTemplateOutlet="area"></ng-container>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-primary" (click)="addKeyword()"><i class="fas fa-plus"></i>Keyword</button>
    </div>
    <div class="col-auto">
      <button type="button" class="btn btn-warning" (click)="toggleAddingKeyword()">Cancel</button>
    </div>
  </div>
}
@else {
  <div class="d-flex">
      @if (maximumTrackingKeywordsAdded) {
        <div class="p-2">
          <button class="btn btn-primary btn-sm display-title-when-disabled"
            type="button" disabled [title]="'Maximum number of tracking keywords added (' + (keywordConfig?.MaximumTrackingKeywords || defaultMaximumTrackingKeywords) + ')'">
            <i class="fas fa-plus"></i>Keyword
          </button>
        </div>
        <div class="p-2 ms-auto">
          <ng-container *ngTemplateOutlet="csvExample"></ng-container>
          <button class="btn btn-primary btn-sm display-title-when-disabled"
            type="button" disabled [title]="'Maximum number of tracking keywords added (' + (keywordConfig?.MaximumTrackingKeywords || defaultMaximumTrackingKeywords) + ')'">
            <i class="fa fa-upload"></i>Import Keywords
          </button>
        </div>
      }
      @else {
        <div class="p-2">
          <button class="btn btn-primary btn-sm" type="button" data-toggle="dropdown">
            <i class="fas fa-plus"></i>Keyword
          </button>
          <ul class="dropdown-menu" role="menu">
            <li>
              <button class="btn-link dropdown-item" (click)="toggleAddingKeyword()">Custom Keyword</button>
            </li>
            @if (availableKeywordSuggestions.length) {
              <div class="dropdown-divider"></div>
              <app-components-shared-keyword-research-keyword-suggestion-filter
                [keywordSuggestions]="availableKeywordSuggestions"
                [filteredKeywordSuggestions]="filteredKeywordSuggestions"
                (filterChanged)="filterChanged($event)">
              </app-components-shared-keyword-research-keyword-suggestion-filter>
              @if (filteredKeywordSuggestions.length || filteredTrackingKeywordSuggestions.length) {
                <li onclick="event.stopPropagation()">
                  <div class="dropdown-item">
                    <span class="keyword-suggestion-keyword"><!-- Keyword --></span>
                    <span class="text-end keyword-suggestion-metrics">
                      <span class="badge keyword-suggestion-volume-badge bg-primary">Volume</span> 
                      <span class="badge keyword-suggestion-competition-badge bg-primary">Competition</span>
                      <span class="badge keyword-suggestion-rank-badge bg-primary">Rank</span>
                    </span>
                  </div>
                </li>
              }
              <div class="keyword-suggestion-list">
              <ng-container *ngFor="let keywordSuggestion of filteredKeywordSuggestions | orderBy: keywordSort">
                <li>
                  <button class="btn-link dropdown-item"
                    (click)="addKeywordSuggestion(keywordSuggestion)">
                    <div>
                      <span class="keyword-suggestion-keyword">
                        {{ keywordSuggestion.KeywordPhrase }}
                      </span>
                      <span class="text-end keyword-suggestion-metrics">
                        @if (keywordSuggestion.Volume !== null) {
                          <span class="badge keyword-suggestion-volume-badge bg-secondary">{{ keywordSuggestion.Volume }}</span>
                        } @else {
                          <span class="keyword-suggestion-volume-badge"></span>
                        }
                        @if (keywordSuggestion.CompetitionDescription) {
                          <span class="badge keyword-suggestion-competition-badge" [ngClass]="{
                            'bg-warning': keywordSuggestion.CompetitionDescription === 'High' || keywordSuggestion.CompetitionDescription === 'Medium',
                            'bg-success': keywordSuggestion.CompetitionDescription === 'Low'}">{{ keywordSuggestion.CompetitionDescription }}</span>
                        } @else {
                          <span class="keyword-suggestion-competition-badge"></span>
                        }
                        @if (keywordSuggestion.Rank) {
                          <span class="badge keyword-suggestion-rank-badge bg-secondary"
                            [ngClass]="{'bg-warning': keywordSuggestion.Rank <= rankThreshold}">{{ keywordSuggestion.Rank }}</span>
                        } @else {
                          <span class="keyword-suggestion-rank-badge"></span>
                        }
                      </span>
                    </div>
                </button>
                </li>
              </ng-container>
              <ng-container *ngFor="let trackingKeywordSuggestion of filteredTrackingKeywordSuggestions | orderBy: keywordSort">
                <li>
                  <button class="btn-link dropdown-item"
                  (click)="addTrackingKeywordSuggestion(trackingKeywordSuggestion)">
                  <div>
                    <span class="keyword-suggestion-keyword">
                      {{ trackingKeywordSuggestion.KeywordPhrase }}
                    </span>
                    <span class="text-end keyword-suggestion-metrics">
                      @if (trackingKeywordSuggestion.Volume !== null) {
                        <span class="badge keyword-suggestion-volume-badge bg-secondary">{{ trackingKeywordSuggestion.Volume }}</span>
                      } @else {
                        <span class="keyword-suggestion-volume-badge"></span>
                      }
                      @if (trackingKeywordSuggestion.CompetitionDescription) {
                        <span class="badge keyword-suggestion-competition-badge" [ngClass]="{
                          'bg-warning': trackingKeywordSuggestion.CompetitionDescription === 'High' || trackingKeywordSuggestion.CompetitionDescription === 'Medium',
                          'bg-success': trackingKeywordSuggestion.CompetitionDescription === 'Low'}">{{ trackingKeywordSuggestion.CompetitionDescription }}</span>
                      } @else {
                        <span class="keyword-suggestion-competition-badge"></span>
                      }
                      @if (trackingKeywordSuggestion.Rank) {
                        <span class="badge keyword-suggestion-rank-badge bg-secondary"
                          [ngClass]="{'bg-warning': trackingKeywordSuggestion.Rank <= rankThreshold}">{{ trackingKeywordSuggestion.Rank }}</span>
                      } @else {
                        <span class="keyword-suggestion-rank-badge"></span>
                      }
                    </span>
                  </div>
                </button>
                </li>
              </ng-container>
            </div>
            }
          </ul>
        </div>
        <div class="p-2 ms-auto">
          <ng-container *ngTemplateOutlet="csvExample"></ng-container>
          <button class="btn btn-primary btn-sm" type="button" (click)="openFileImport()">
            <i class="fa fa-upload"></i>Import Keywords
          </button>
          <input #fileInput type='file' accept=".csv" (change)="importKeywordSuggestions($event)" hidden>
        </div>
      }
  </div>
}

<ng-template #keyword>
  <div class="input-group mb-0" [formValidation]="formGroup">
    <span class="input-group-text">Keyword</span>
    <input #keywordInput type="text" class="form-control" [formControl]="keywordControl"
      [formValidation]="keywordControl" (keyup.enter)="addKeyword()"/>
  </div>
</ng-template>

<ng-template #area>
  <div class="input-group mb-0" [formValidation]="formGroup">
    <span class="input-group-text">Location</span>
    <input #areaInput type="text" class="form-control" [formControl]="areaControl"
      [formValidation]="areaControl" (keyup.enter)="addKeyword()" />
  </div>
</ng-template>

<ng-template #csvExample>
  @if (customer.IsCampaignNational) {
    <a [attr.href]="nationalCampaignExampleCsv" target="_blank" class="me-2">Example National CSV</a>
  }
  @else {
    <a [attr.href]="localCampaignExampleCsv" target="_blank" class="me-2">Example Local CSV</a>
  }
</ng-template>